import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import { TableRow, TableCell, Switch, Tooltip, Button } from '@material-ui/core';
import { Domain } from '@material-ui/icons';
import grey from '@material-ui/core/colors/grey';

import ResourceValue from '../resources/ResourceValue';
import { FormattedMessage } from 'react-intl';

const styles = theme => ({
  row: {
    backgroundColor: grey[200],
  },
  tools: {
    textAlign: "right"
  },
  largeCell: {
    width: 360
  },
  iconButton: {
    color: grey[600],
  },
  full: {
    overflow: 'auto',
  },
  fakeButton: {
    color: 'white',
    backgroundColor: '#C3CBD9',
    '&:hover': {
      backgroundColor: '#C3CBD9',
    },
    marginRight: 8
  },
  tooltip: {
    maxWidth: 'none',
    fontSize: 12,
  }
});

/**
 * Admin User Row in User Tab
 * Allows to add or remove manager's subscription from subscriptions
 */

class UserAdminRow extends Component {

  state = {
    switchOn: this.props.switchOn
  }

  handleRemoveAdmin (admin) {
    this.setState({switchOn: false});
    this.props.handleRemoveAdmin(admin);
  }

  handleAddAdmin (admin) {
    this.setState({switchOn: true});
    this.props.handleAddAdmin(admin);
  }

  render() {
    const {
      subscription,
      user,
      classes,
      switchOn,
    } = this.props;

    const displayableResources = subscription.resources 
      ? subscription.resources.filter(resource => resource.id !== 'owners')
      : [];

    const resourcesById = user.resources.reduce((memo, resource) => ({
      ...memo,
      [resource.id]: resource
    }), {});

    const domainInvitationsCount = subscription.domainInvitationsCount;

    const SwitchOnTooltipText = <FormattedMessage id='user.admin.switchOn.tooltip.text'/>
    const SwitchOffTooltipText = <FormattedMessage id='user.admin.switchOff.tooltip.text'/>

    return (
        
      <TableRow key={user.id} className={classes.row}>
        <TableCell className={classes.largeCell}>
          <Button  size="small" className={classes.fakeButton} disableFocusRipple={true} disableRipple={true} onClick={() => null}>
            <FormattedMessage id='user.admin.status.indicator.text'/>
          </Button>
          {user.firstName} {user.lastName}
        </TableCell>
        <TableCell>
          {user.email}
        </TableCell>
        {
          domainInvitationsCount >= 1?
            <TableCell >
              {user.isFromDomainInvitation ? <Domain className={classes.iconButton} /> : null}
            </TableCell>
            : null
        }
        {displayableResources.map(({id}) => {
          const resource = resourcesById[id];
          if( resource ){
            return (
              <TableCell key={id}>
                <ResourceValue resource={resource} displayValue displayUnit />
              </TableCell>
              )
          }
          return null;
        })}
        
        <TableCell className={classes.tools}>
          <Tooltip interactive classes={{ tooltip: classes.tooltip }} title={this.state.switchOn? SwitchOffTooltipText : SwitchOnTooltipText} placement="bottom-end">
            <span>
              <Switch
                checked={this.state.switchOn}
                onChange={switchOn ? () => this.handleRemoveAdmin(user) : () => this.handleAddAdmin(user)}
                value="adminAsAUserSwitcher"
                color="primary"
                disabled={subscription.switching || (this.state.switchOn ? false : subscription.licencesCount <= subscription.usedLicencesCount)}
                inputProps={{ 'aria-label': 'adminAsAUserSwitcher' }}
              />
            </span>
          </Tooltip>
        </TableCell>
      </TableRow>
    )      
  }
}

UserAdminRow.propTypes = {
  classes: PropTypes.object.isRequired,
  handleAddAdmin: PropTypes.func.isRequired,
  handleRemoveAdmin: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
}

export default withStyles(styles)(
  UserAdminRow
);


// WEBPACK FOOTER //
// ./src/components/subscriptions/UserAdminRow.js